import classes from './workOrderReport.module.css';

interface Props {
  reportAssets: any[];
}

const ReportAssetsSection = ({ reportAssets = [] }: Props) => {
  const assetNames = reportAssets.map(asset => asset?.name);

  return <div className={classes.basicContainer}>{assetNames.join(', ')}</div>;
};

export default ReportAssetsSection;
